import React from 'react';
import PropTypes from 'prop-types';
import DeleteAction from 'components/field/DropDownActionsMenu/DeleteAction';
import DropDownActionsMenu from 'components/field/DropDownActionsMenu/DropDownActionsMenu';
import EditAction from 'components/field/DropDownActionsMenu/EditAction';
import HeaderColumn from 'components/ui/table/HeaderColumn';
import MobianReferenceById from 'components/field/MobianReferenceById';
import NoResults from 'components/form/styling/NoResults';
import PropertyIcon from 'components/field/PropertyIcon';
import Table from 'components/ui/table/Table';
import TableRow from 'components/ui/table/TableRow';
import translate from 'components/hoc/translate';
import Loader from 'components/loading/Loader';
import TableBodyCell from 'components/table/TableBodyCell';
import TextField from 'components/show/TextField';
import compose from 'recompose/compose';
import utils from 'helpers/utils';
import { connect } from 'react-redux';
import { deleteProductProperty } from 'store/actions/productProperties/deleteProductProperties';
import { fetchProductProperties } from 'store/actions/productProperties/fetchProductProperties';

class Properties extends React.PureComponent {
    static propTypes = {
        record: PropTypes.object.isRequired,
    }

    componentDidMount() {
        // Fetch all the current product properties.
        this.props.fetchProductProperties({
            productId: this.props.record.id,
        });
    }

    render() {
        const {
            record,
            properties,
            isLoading,
            resource,
            translate,
        } = this.props;

        if (utils.isEmpty(record)) {
            return null;
        }

        if (isLoading) {
            return <Loader />;
        }

        if (utils.isEmpty(properties)) {
            return <NoResults label='resources.products.properties.no_results' />;
        }

        const sorted = utils.sort(properties, 'priority', 'desc');

        return (
            <Table responsive='scroll'>
                <TableRow>
                    <HeaderColumn style={ { width: '40%' } }>{ translate('resources.products.fields.property_id') }</HeaderColumn>

                    <HeaderColumn style={ { width: '25%' } }>{ translate('resources.properties.fields.icon') }</HeaderColumn>

                    <HeaderColumn style={ { width: '25%' } }>{ translate('resources.products.fields.priority') }</HeaderColumn>

                    <HeaderColumn style={ { width: '10%' } }>&nbsp;</HeaderColumn>
                </TableRow>

                {
                    utils.map(sorted, (row) => {
                        return (
                            <TableRow key={ row.id }>
                                <TableBodyCell
                                    record={ row }
                                    resource={ resource }
                                    source='property_id'
                                    field= {
                                        <MobianReferenceById
                                            type='property'
                                            value={ row.property_id }
                                        />
                                    }
                                />

                                <TableBodyCell
                                    field={ <PropertyIcon id={ row.property_id } /> }
                                    record={ row }
                                    source='icon'
                                    resource={ resource }
                                />

                                <TableBodyCell
                                    field={ <TextField value={ row.priority } /> }
                                    record={ row }
                                    source='priority'
                                />

                                <TableBodyCell
                                    field={
                                        <DropDownActionsMenu>
                                            <EditAction url={ `/products/${ record.id }/properties/${ row.id }/edit` } />

                                            <DeleteAction
                                                action={ deleteProductProperty }
                                                params={ {
                                                    productId: record.id,
                                                    propertyId: row.id,
                                                } }
                                            />
                                        </DropDownActionsMenu>
                                    }
                                    record={ record }
                                    resource={ resource }
                                />
                            </TableRow>
                        );
                    })
                }
            </Table>
        );
    }
}

Properties.defaultProps = {
    resource: 'properties',
};

Properties.propTypes = {
    fetchProductProperties: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    properties: PropTypes.object,
    record: PropTypes.object,
    resource: PropTypes.string,
    translate: PropTypes.func,
};

const enhance = compose(
    connect(
        (state, props) => {
            return {
                isLoading: state.productProperties.loading,
                properties: state.productProperties.data[props.record.id],
            };
        },
        {
            fetchProductProperties: fetchProductProperties,
        },
    ),
    translate,
);

export default enhance(Properties);



// WEBPACK FOOTER //
// ./src/pages/products/show/Properties.js